import {
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { UIFormLabel } from "../ui/ui-form-label";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { FC, useRef } from "react";
import XmarkIcon from "@/app/assets/icons/xmark.svg?react";
import { DidoxPreviewModalRef } from "../modals/didox-preview-modal/types";
import { DidoxPreviewModal } from "../modals/didox-preview-modal";
import { RequestDocumentType } from "@/features/create-seller-request-form/types";

interface Props {
  value: RequestDocumentType;
  onDelete?: () => void;
  showPreview?: boolean;
  showPdf?: boolean;
  showHtml?: boolean;
}

export const DidoxDocumentWidget: FC<Props> = ({
  value,
  onDelete,
  showPreview,
  showHtml,
  showPdf,
}) => {
  const { t } = useTranslation();

  const didoxHtmlModalRef = useRef<DidoxPreviewModalRef>(null);

  const fileName =
    value && "value" in value
      ? typeof value.value === "string"
        ? value?.name || ""
        : value.value.name
      : value?.name || "";

  const openDidoxHtmlModal = () => {
    if (!value) return;

    if ("doc_id" in value) {
      didoxHtmlModalRef.current?.open({
        id: value.doc_id,
        name: fileName,
      });
    } else if ("value" in value) {
      didoxHtmlModalRef.current?.open({
        file: value.value,
        name: fileName,
      });
    }
  };

  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        border: "1px solid rgba(230, 241, 255, 1)",
        borderRadius: "6px",
        position: "relative",
      }}
    >
      <Grid container alignItems="center">
        {value && "doc_id" in value ? (
          <>
            <Grid item md={showPreview ? 3 : 4} xs={12}>
              <UIFormLabel>
                {t(`common:doctypes.${value.doctype}`)}{" "}
                {t("common:from_value", {
                  date: dayjs(value.created, "YYYY-MM-DD").format("DD.MM.YYYY"),
                }).toLowerCase()}
              </UIFormLabel>
              <Typography fontSize={13}>{value.name}</Typography>
            </Grid>
            <Grid item md={showPreview ? 3 : 4} xs={12}>
              <UIFormLabel>
                {t("common:contragent", { date: value.created })}:
              </UIFormLabel>
              <Typography fontSize={13}>{value.partnerCompany}</Typography>
            </Grid>
            <Grid item md={showPreview ? 3 : 4} xs={12}>
              <UIFormLabel>
                {t("common:rouming_id", { date: value.created })}:
              </UIFormLabel>
              <Typography fontSize={13}>
                {value.roaming_id?.toUpperCase()}
              </Typography>
            </Grid>
          </>
        ) : (
          <>
            <Grid item flex={1}>
              <UIFormLabel>{t("common:file_name")}:</UIFormLabel>
              <Typography fontSize={13}>{fileName}</Typography>
            </Grid>
          </>
        )}
        {(showPreview || onDelete) && (
          <Grid
            item
            md={3}
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Stack direction="row" alignItems="center" spacing={0.5}>
              {showPreview && (
                <Button color="inherit" onClick={openDidoxHtmlModal}>
                  {t("look")}
                </Button>
              )}
              {onDelete && (
                <IconButton onClick={onDelete}>
                  <Box component={XmarkIcon} />
                </IconButton>
              )}
            </Stack>
          </Grid>
        )}
      </Grid>

      <DidoxPreviewModal
        ref={didoxHtmlModalRef}
        showPdf={value && "diodxId" in value ? showPdf || false : true}
        showHtml={showHtml}
      />
    </Box>
  );
};
